<template>
  <el-dialog title="订单导出" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
             :close-on-press-escape="false" size="medium" width="50%">
 <div class="common-seach-wrap">
   <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
     <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号"></el-input></el-form-item>
     <el-form-item label="买家ID">
       <el-input size="small" style="width:100px" v-model="searchForm.user_id" placeholder="买家ID"></el-input>
     </el-form-item>
     <el-form-item label="收货人">
          <el-input size="small" style="width:120px" v-model="searchForm.address" placeholder="姓名或手机"></el-input>
        </el-form-item>
     <el-form-item label="商品名称">
       <el-input size="small" style="width:150px" v-model="searchForm.product_name" placeholder="商品名称"></el-input>
     </el-form-item>
     <el-form-item label="商品编号">
        <el-input size="small" style="width:150px" v-model="searchForm.product_no" placeholder="商品编号"></el-input>
      </el-form-item>
      <el-form-item label="快递单号">
        <el-input size="small" style="width:150px" v-model="searchForm.express_no" placeholder="快递单号"></el-input>
      </el-form-item>
     <el-form-item label="商品分类">
       <el-select v-model="searchForm.category_id">
         <template v-for="cat in categoryList">
           <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
           <template v-if="cat.child !== undefined" v-for="two in cat.child">
             <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
             <template v-if="two.child !== undefined" v-for="three in two.child">
               <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>
             </template>
           </template>
         </template>
       </el-select>
     </el-form-item>
     <el-form-item label="配送方式">
       <el-select size="medium" v-model="searchForm.style_id" placeholder="请选择">
         <el-option label="全部" value=""></el-option>
         <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name" :value="item.value"></el-option>
       </el-select>
     </el-form-item>
     <el-form-item label="自提门店">
       <el-select size="small" v-model="searchForm.store_id" placeholder="请选择">
         <el-option label="全部" value=""></el-option>
         <el-option v-for="(item, index) in shopList" :key="index" :label="item.store_name" :value="item.store_id"></el-option>
       </el-select>
     </el-form-item>
     <el-form-item label="起始时间">
       <div class="block">
         <span class="demonstration"></span>
         <el-date-picker
           size="small"
           v-model="searchForm.create_time"
           type="daterange"
           value-format="yyyy-MM-dd"
           range-separator="至"
           start-placeholder="开始日期"
           end-placeholder="结束日期"
         ></el-date-picker>
       </div>
     </el-form-item>
     <el-form-item label="订单导出范围">
       <el-select v-model="activeName" placeholder="请选择">
           <el-option
             v-for="item in options"
             :key="item.value"
             :label="item.label"
             :value="item.value">
           </el-option>
         </el-select>
     </el-form-item>
   </el-form>
 </div>
 <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
 @change="handleCheckAllChange" class="ing">
   全选
 </el-checkbox>
<el-checkbox-group v-model="datascheck" @change="handleCheckedCitiesChange">
  <el-checkbox v-for="data in orderData" :label="data" :key="data" class="ing">
  {{data}}
  </el-checkbox>
</el-checkbox-group>
 <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible">取 消</el-button>
          <el-button type="primary" @click="onExtract(datascheck)" :loading="loading">导出订单</el-button>
      </div>
  </el-dialog>
</template>

<script>
  import OrderApi from '@/api/order.js';
  import qs from 'qs';
  // 订单可选列表
  const orderData = ["订单号","商品信息","订单总额","优惠券抵扣","积分抵扣","运费金额","后台改价","实付款金额","支付方式","下单时间","买家","买家留言","配送方式","自提门店名称","自提联系人","自提联系电话","收货人姓名","联系电话","收货人地址","物流公司","物流单号","付款状态","付款时间","发货状态","发货时间","收货状态","收货时间","订单状态","微信支付交易号","是否已评价"];
  export default {
    data() {
        return {
          /*是否显示*/
          dialogVisible: true,
          //选中列表
          datascheck: ["订单号","商品信息","订单总额","优惠券抵扣","积分抵扣","运费金额","后台改价","实付款金额","支付方式","下单时间","配送方式","收货人姓名","联系电话","收货人地址","物流公司","物流单号","付款状态","付款时间","发货状态","发货时间","收货状态","收货时间","订单状态"],
          orderData: orderData,

          //全选
          checkAll: false,
          isIndeterminate: true,
          //订单导出范围
          options: [{value: 'all',label: '全部订单'}, {value: 'payment',label: '未付款'},
          {value: 'delivery',label: '待发货'}, {value: 'apply_cancle',label: '申请取消'},
          {value: 'received',label: '待收货'}, {value: 'comment',label: '待评价'},
          {value: 'six',label: '已完成'}],
          activeName: 'all',

          /*横向表单数据模型*/
          searchForm: {
            user_id: "",
            address:"",
            order_no: "",
            product_name: "",
            product_no: "",
            express_no: "",
            category_id: "",
            style_id: '',
            store_id: '',
            create_time: ''
          },
          /*配送方式*/
          exStyle: [],
          /*门店列表*/
          shopList: [],
          /*分类列表*/
          categoryList: [],
      };

    },
    created() {
      /*获取列表*/
      this.getParams();
    },
    methods: {
      handleCheckAllChange(val) {
              this.datascheck = val ? orderData : [];
              this.isIndeterminate = false;
            },
      handleCheckedCitiesChange(value) {
              let checkedCount = value.length;
              this.checkAll = checkedCount === this.orderData.length;
              this.isIndeterminate = checkedCount > 0 && checkedCount < this.orderData.length;
            },

            /*获取参数*/
            getParams() {
              let self = this;
              OrderApi.orderlistpart({},true)
                .then(res => {
                  self.loading = false;
                  self.exStyle = res.data.ex_style;
                  self.shopList = res.data.shop_list;
                  self.categoryList = res.data.catgory;
                })
                .catch(error => {
                  self.loading = false;
                });
            },

      /*订单导出*/
      onExtract(e) {
        let self = this;
        let datascheck = e;
        let searchForm = self.searchForm;
        let activeName = self.activeName;
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let data = [datascheck,searchForm,activeName]
        window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(data);
        self.dialogFormVisible();
      },
      /*关闭弹窗*/
      dialogFormVisible() {
          this.$emit('closeDialog', {openDialog: false});
      }

    },
};
</script>

<style>
  .ing{
    height:30px;
    width:130px;
  }
</style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/FileExport.vue